import { jwtDecode } from 'jwt-decode';

export const isTokenExpired = () => {
    try {
        const account = localStorage.getItem('account');
        const token = account.token;
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        return decodedToken.exp < currentTime;
    } catch (error) {
        return true;
    }
};

export const getEnumKey = (object, value) => {
    if (!object) return null;

    const key = Object.keys(object).find((key) => object[key] === value);
    if (key) {
        return key;
    } else {
        return null;
    }
};

export const deIdentifyText = (text) => {
    if (text.length === 2) {
        return text.replace(/(?<=^.)./, '*');
    } else if (text.length > 2) {
        return text.replace(/(?<=^.)(.*)(?=.$)/, (match) => '*'.repeat(match.length));
    } else {
        return text;
    }
};

export const scoreRole = (role) => {
    let score = 0;
    switch (role) {
        case 'COM017_10':
            score = 1;
            break;
        case 'COM017_20':
            score = 1;
            break;
        case 'COM017_30':
            score = 3;
            break;
        case 'COM017_40':
            score = 2;
            break;
        case 'COM017_50':
            score = 1;
            break;
        case 'COM017_60':
            score = 4;
            break;
        default:
            score = 0;
            break;
    }

    return score;
};

export const compareRole = (source, target) => {
    let sourceScore = scoreRole(source);
    let targetScore = scoreRole(target);

    if (source === target || sourceScore === targetScore) return 0;

    if (sourceScore > targetScore) return 1;
    else return -1;
};
